import React, { Fragment, useEffect, useState, useCallback } from "react"
import { Row, Col, Card, CardBody, Button, Badge, Spinner } from "reactstrap"
import { UncontrolledTooltip } from "reactstrap"
import { Link, useHistory, useLocation } from "react-router-dom"
import { useDispatch, useSelector } from "react-redux"
import Select from "react-select"
import SimpleBar from "simplebar-react"
import { TbClockExclamation } from "react-icons/tb"

// data table related plugins
import BootstrapTable from "react-bootstrap-table-next"
import { map, range, debounce } from "lodash"

import ToolkitProvider from "react-bootstrap-table2-toolkit"
import MyPagination from "../../components/Common/MyPagination"

//actions

import "../../assets/scss/datatables.scss"

import DeleteModal from "components/Common/DeleteModal"

import {
  deleteLead,
  getClients,
  getExcelDownloadLead,
  getLeads,
  getUsers,
  getVehicles,
  resetClientNumber,
} from "store/actions"
import ReactDrawer from "react-drawer"
import { FaList, FaFire, FaFireAlt, FaSun } from "react-icons/fa"
import { PiTableFill } from "react-icons/pi"
import ExcelDownload from "hooks/useExcelDownloadButton"
import moment from "moment"
import PropTypes from "prop-types"
import useGetBranchDetails from "components/Common/Hooks/useGetBranchDetails"
import { useRole, ROLE_TYPES } from "hooks/useRole"
import useHandleStatusValue from "hooks/useHandleStatusValue"
import useLeadStatus from "hooks/useLeadStatus"

const Leads = ({ vehicleDetailsId }) => {
  const dispatch = useDispatch()
  const history = useHistory()
  const location = useLocation()
  const { canCreateLead } = useRole()

  const {
    allLeads,
    count,
    loading,
    allVehicle,
    allLeadsExcel,
    allClients,
    statusCount,
    allStaffs,
    excelLoading,
  } = useSelector(state => ({
    allLeads: state?.Lead?.leads?.leads,
    loading: state?.Lead?.loading,
    count: state?.Lead?.leads?.total,
    allVehicle: state.Vehicle.vehicles?.vehicles,
    allLeadsExcel: state.ExcelDownload?.excelDownloadLead.leads,
    allClients: state?.Client?.clients?.clients,
    statusCount: state?.Lead?.leads?.statusCounts,
    allStaffs: state?.Members?.users?.users,
    excelLoading: state.ExcelDownload?.loading,
  }))

  const { branchId } = useGetBranchDetails()
  const { getStatusColor, getStatusLabel } = useLeadStatus()

  const total = count

  // Initialize all state from location.state so the first render
  // already has the correct filters — eliminates the back-navigation flicker.
  const savedState = location?.state || {}

  const [totalItemLimit, setTotalItemLimit] = useState(savedState.limit || 30)
  const [page, setPage] = useState(null)

  const [sort, setSort] = useState(savedState.sort || "all")

  const [vehicle, setVehicle] = useState(savedState.vehicleName || "Select Vehicle...")
  const [vehicleId, setVehicleId] = useState(savedState.vehicle || "")
  const [vehicleSearch, setVehicleSearch] = useState("")

  const [client, setClient] = useState(savedState.clientName || "Select Client...")
  const [clientId, setClientId] = useState(savedState.client || "")
  const [clientSearch, setClientSearch] = useState("")

  const [staff, setStaff] = useState(() => {
    if (savedState.staff && savedState.staffNames) {
      const ids = savedState.staff.split(',').filter(Boolean)
      const names = savedState.staffNames.split(', ')
      return ids.map((id, i) => ({ value: id, label: names[i] || id }))
    }
    return []
  })
  const [staffId, setStaffId] = useState(() => {
    if (savedState.staff) return savedState.staff.split(',').filter(Boolean)
    return []
  })
  const [staffSearch, setStaffSearch] = useState("")

  const [typeValue, setTypeValue] = useState("")

  const [layout, setLayout] = useState("list")
  const [open, setOpen] = useState(false)
  const [position, setPosition] = useState("right")

  const [medium, setMedium] = useState(savedState.medium || "")
  const [leadCondition, setLeadCondition] = useState(savedState.leadCondition || "all")
  const [searchText, setSearchText] = useState(savedState.searchText || "")
  const [debouncedSearchText, setDebouncedSearchText] = useState(savedState.searchText || "")
  const [orderValue, setOrderValue] = useState(savedState.orderValue || "createdAt_-1")
  const [finalDateFormatted, setFinalDateFormatted] = useState({
    from: savedState.dateFrom || "",
    to: savedState.dateTo || "",
  })

  // Debounce search input
  const debouncedSearch = useCallback(
    debounce(value => {
      setDebouncedSearchText(value)
    }, 500),
    []
  )

  const updateURLParams = (key, value, extraState = {}) => {
    const searchParams = new URLSearchParams(location.search)
    searchParams.set("p", 1)

    if (location?.pathname !== "/dashboard") {
      history.push({
        pathname: location.pathname,
        search: searchParams.toString(),
        state: {
          ...location.state,
          page: 1,
          ...extraState,
          [key]: value,
        },
      })
    }
  }

  const handleSearchChange = e => {
    const value = e.target.value
    setSearchText(value)
    debouncedSearch(value)
    updateURLParams("searchText", value)
  }

  const handleClearSearch = () => {
    setSearchText("")
    setDebouncedSearchText("")
    updateURLParams("searchText", "")
  }

  const handleDateSearch = () => {
    if (
      finalDateFormatted?.from?.length >= 1 &&
      finalDateFormatted?.to?.length >= 1
    ) {
      return finalDateFormatted
    } else {
      return {
        from: "",
        to: "",
      }
    }
  }

  const { isAnyRole, isRole } = useRole()

  useEffect(() => {
    if (vehicleDetailsId) {
      setVehicleId(vehicleDetailsId)
    }
  }, [vehicleDetailsId])

  //delete
  const [isOpen, setIsOpen] = useState({ status: false, id: "" })
  const handleDeleteEvent = () => {
    setIsOpen({ ...isOpen, status: false })
    dispatch(deleteLead(isOpen?.id, ""))
  }

  useEffect(() => {
    setPage(1)
  }, [])

  useEffect(() => {
    console.log("branchId", branchId)
    if (page) {
      // Convert staffId array to comma-separated string
      const staffIdsString = Array.isArray(staffId) ? staffId.join(',') : staffId

      const [order, orderType] = orderValue ? orderValue.split("_") : ["", ""];

      dispatch(
        getLeads(
          page,
          sort,
          totalItemLimit,
          debouncedSearchText, // searchText
          vehicleId,
          typeValue,
          clientId,
          medium,
          handleDateSearch(),
          staffIdsString,
          branchId,
          leadCondition === 'all' ? '' : leadCondition,
          order,
          orderType
        )
      )
    }
  }, [
    dispatch,
    page,
    sort,
    totalItemLimit,
    vehicleId,
    typeValue,
    clientId,
    medium,
    leadCondition,
    finalDateFormatted,
    staffId,
    branchId,
    debouncedSearchText,
    orderValue,
  ])

  //pagination
  const totalPages = Math.ceil(total / totalItemLimit)
  const pages = range(1, totalPages + 1)

  const columns = [
    {
      dataField: "list",
      filterText: "",
      text: "#",
      sort: true,
    },
    {
      dataField: "isFollowupCreated",
      filterText: "",
      text: "",
      sort: true,
    },
    {
      dataField: "createdAt",
      filterText: "createdAt",
      text: orderValue === "updatedAt_-1" || orderValue === "updatedAt_1" ? "Updated At" : "Create At",
    },
    {
      dataField: "client",
      filterText: "client",
      text: "Client",
    },
    {
      dataField: "medium",
      filterText: "medium",
      text: "Medium",
      sort: true,
    },
    {
      dataField: "vehicle",
      filterText: "vehicle",
      text: "Vehicle",
    },
    // {
    //   dataField: "leadType",
    //   filterText: "leadType",
    //   text: "Lead Type",
    //   sort: true,
    // },

    {
      dataField: "assignee",
      filterText: "assignee",
      text: "Assignee",
    },
    {
      dataField: "branch",
      filterText: "branch",
      text: "Branch",
    },
    {
      dataField: "status",
      filterText: "status",
      text: "Status",
      sort: true,
    },

    {
      dataField: "action",
      text: "Actions",
    },
  ]

  const handleColumns = () => {
    if (vehicleDetailsId) {
      return columns?.filter(i => i.dataField !== "vehicle")
    } else return columns
  }


  const handleLeadType = leadType => {
    switch (leadType) {
      case "dream_car":
        return "info"
      case "sales":
        return "success"
      case "purchase":
        return "danger"
      default:
        return "info"
    }
  }
  const handleLeadTypes = leadType => {
    switch (leadType) {
      case "dream_car":
        return "Dream Car"
      case "sales":
        return "sales"
      case "purchase":
        return "purchase"
      default:
        return ""
    }
  }

  // Use hook methods for status handling
  const handleOrderStatus = status => getStatusColor(status)
  const handleCheckStatus = (status, leadType) => getStatusLabel(status, leadType)

  //all
  const allLeadData = map(allLeads, (item, index) => {
    return {
      ...item,
      key: item._id,
      createdAt: (
        <span>
          {moment(
            orderValue === "updatedAt_-1" || orderValue === "updatedAt_1"
              ? item?.updatedAt
              : item?.createdAt
          ).format("DD-MM-YYYY")}
        </span>
      ),

      list: (
        <div className="d-flex align-items-center">
          {item?.leadCondition === 'superHot' ? (
            <FaFire className="text-danger" style={{ fontSize: '12px' }} />
          ) : item?.leadCondition === 'hot' ? (
            <FaFireAlt className="text-warning" style={{ fontSize: '12px' }} />
          ) : item?.leadCondition === 'warm' ? (
            <FaSun className="text-info" style={{ fontSize: '12px' }} />
          ) : null}
          <span className="me-2">&nbsp; {index + 1 + (page - 1) * totalItemLimit}</span>
        </div>
      ),

      isFollowupCreated:
        item?.status === "new" &&
          item?.createdAt &&
          item?.createdAt >= moment().startOf("day").fromNow() &&
          item?.isFollowupCreated === false ? (
          <span>
            <TbClockExclamation style={{ color: "red", fontSize: 20 }} />
          </span>
        ) : (
          ""
        ),

      assignee: (
        // <Link to={`/client/details/${item?.assignee?._id}`}>
        <Link to={`/lead-details/${item?._id}`} className="text-black">
          <p className="m-0 p-0">{item?.assignee?.name}</p>
        </Link>
      ),
      branch: (
        <p className="m-0 p-0">
          {item?.branch?.branch_name || item?.branch?.name || "---"}
        </p>
      ),
      message: (
        <p className="m-0 p-0">
          {item?.message?.length >= 30
            ? item?.message?.slice(0, 30 - 1) + "..."
            : item?.message}
        </p>
      ),
      medium: item?.medium && (
        <Badge
          style={{ textTransform: "capitalize" }}
          className={"px-2 py-2 badge-soft-info"}
        >
          {" "}
          {item?.medium === "direct" ? "Walk-In" : item?.medium}{" "}
        </Badge>
      ),


      client: (
        <p className="m-0 p-0">
          {/* <Link to={`/client/details/${item?.client?._id}`}> */}
          <Link to={`/lead-details/${item?._id}`}>{item?.client?.name}</Link>
          <br />
          <span style={{ color: "#6c757d", fontSize: "0.7rem" }}>
            {item?.client?.countryCode || "+91"} {item?.client?.phone || "----"}
          </span>
        </p>
      ),
      vehicle: (
        <p className="m-0 p-0">
          {item?.vehicle ? (
            // <Link to={`/vehicle/details/${item?.vehicle?._id}`}>
            <Link to={`/lead-details/${item?._id}`} className="text-black">
              {item?.vehicle?.name}
            </Link>
          ) : item?.requestedVehicle?.brand?.name ||
            item?.requestedVehicle?.model?.name ? (
            <>
              <UncontrolledTooltip
                placement="top"
                target={`brand-and-model-${item?._id}`}
              >
                brand and model
              </UncontrolledTooltip>
              <p id={`brand-and-model-${item?._id}`}>
                {item?.requestedVehicle?.brand?.name || "---"}{" "}
                {item?.requestedVehicle?.model?.name || "---"}
              </p>
            </>
          ) : (
            "---"
          )}
        </p>
      ),
      leadType: item?.leadType && (
        <Badge
          style={{ textTransform: "capitalize" }}
          className={
            "px-2 py-2 badge-soft-" + `${handleLeadType(item?.leadType)}`
          }
        >
          {" "}
          {handleLeadTypes(item?.leadType)}{" "}
        </Badge>
      ),
      status: item?.status && (
        <Badge
          style={{ textTransform: "capitalize" }}
          className={
            "px-2 py-2 badge-soft-" + `${handleOrderStatus(item?.status)}`
          }
        >
          {" "}
          {handleCheckStatus(item?.status, item?.leadType || typeValue)}{" "}
        </Badge>
      ),
      action: (
        <div>
          <Link to={`/lead-details/${item?._id}`}>
            <Button
              id={`view${index}`}
              type="button"
              color="white"
              className="ms-1 btn"
            >
              <i
                className="bx bx-show-alt me-2"
                style={{ color: "green", fontSize: "24px" }}
              />
            </Button>
          </Link>
        </div>
      ),
    }
  })

  const listChange = sortValue => {
    setSort(sortValue)
    updateURLParams("sort", sortValue)
  }

  const handlePageLimit = e => {
    const newLimit = parseInt(e.target.value)
    if (e.target.value >= 1) {
      setTotalItemLimit(newLimit)
      updateURLParams("limit", newLimit)
    }
  }

  const bool = false

  useEffect(() => {
    dispatch(
      getVehicles("", "", vehicleSearch, "", "", "", "", "", "", "", "", bool)
    )
  }, [dispatch, vehicleSearch, bool])

  const handlerVehicleFinalValue = event => {
    setVehicle(event?.label)
    setVehicleId(event?.value)

    updateURLParams("vehicle", event?.value, { vehicleName: event?.label })
  }

  const vehicleOptions = [
    {
      label: "All",
      value: "",
    },
    {
      options: allVehicle?.map((result, index) => ({
        key: index,
        label: result?.name,
        value: result?._id,
      })),
    },
  ]

  const handleEntersVehicle = text => {
    setVehicleSearch(text)
  }

  useEffect(() => {
    dispatch(getClients("", "", clientSearch, "", ""))
  }, [dispatch, clientSearch])

  const clientOptions = [
    {
      label: "All",
      value: "",
    },
    {
      options: allClients?.map((result, index) => ({
        key: index,
        label: result?.phone
          ? `${result?.name} - ${result?.phone}`
          : result?.name,
        value: result?._id,
      })),
    },
  ]

  const handleEntersClients = text => {
    setClientSearch(text)
  }

  const handlerClientFinalValue = event => {
    setClient(event?.label)
    if (event?.value) {
      setClientId(event?.value)
      updateURLParams("client", event?.value, { clientName: event?.label })
    }
  }

  useEffect(() => {
    const searchText1 = staffSearch
    if (
      isAnyRole([
        ROLE_TYPES.SUPER_ADMIN,
        ROLE_TYPES.ADMIN,
        ROLE_TYPES.ENQUIRY_MANAGER,
        ROLE_TYPES.ENQUIRY_ANALYST,
      ])
    ) {
      dispatch(getUsers("", "", searchText1, "", "member")) // staff members only
    }
  }, [dispatch, staffSearch, isAnyRole])

  const staffOptions = allStaffs?.map((result, index) => ({
    key: index,
    label: result?.name,
    value: result?._id,
  })) || []

  const handleEntersStaffs = text => {
    setStaffSearch(text)
  }

  const handlerStaffsFinalValue = selectedOptions => {
    const selectedStaff = selectedOptions || []
    setStaff(selectedStaff)

    // Extract IDs and join with comma
    const staffIds = selectedStaff.map(option => option.value)
    setStaffId(staffIds)

    // Join IDs with comma for API
    const staffIdsString = staffIds.join(',')
    updateURLParams("staff", staffIdsString, {
      staffNames: selectedStaff.map(s => s.label).join(', ')
    })
  }

  const handlerDateFrom = e => {
    setFinalDateFormatted({
      ...finalDateFormatted,
      from: e.target.value,
    })
    updateURLParams("dateFrom", e.target.value)
  }

  const handlerDateTo = e => {
    setFinalDateFormatted({
      ...finalDateFormatted,
      to: e.target.value,
    })
    updateURLParams("dateTo", e.target.value)
  }

  const handlerClearDateFrom = () => {
    setFinalDateFormatted({
      ...finalDateFormatted,
      from: "",
    })
    updateURLParams("dateFrom", "")
  }

  const handlerClearDateTo = () => {
    setFinalDateFormatted({
      ...finalDateFormatted,
      to: "",
    })
    updateURLParams("dateTo", "")
  }

  const filterLabelStyle = {
    fontSize: "12px",
    fontWeight: "600",
    color: "#6c757d",
    marginBottom: "6px",
    display: "flex",
    alignItems: "center",
    gap: "6px",
  }

  const filterIconStyle = {
    fontSize: "14px",
    color: "#556ee6",
  }

  const filterContainerStyle = isListLayout => ({
    background: isListLayout ? "#f8f9fa" : "transparent",
    borderRadius: isListLayout ? "10px" : "0",
    padding: isListLayout ? "12px" : "0",
    marginBottom: isListLayout ? "12px" : "0",
  })

  const headerOptions = (
    <>
      {layout && (
        <div
          className={`headerOptionWrap w-100 mb-3`}
          style={{
            padding: layout === "list" ? "8px" : "0",
          }}
        >
          <div className="headerOptionSubWrap align-items-center flex-wrap">
            <div
              className={`${layout === "list" ? "" : "d-flex flex-wrap align-items-end"
                }`}
              style={{ gap: "12px" }}
            >
              {/* Show Count */}
              <div style={filterContainerStyle(layout === "list")}>
                <div style={filterLabelStyle}>
                  <i className="bx bx-hash" style={filterIconStyle}></i>
                  <span>Show Rows</span>
                </div>
                <div
                  style={{ display: "flex", alignItems: "center", gap: "8px" }}
                >
                  <input
                    type="number"
                    className="form-control"
                    value={totalItemLimit}
                    onChange={e => handlePageLimit(e)}
                    style={{
                      width: "70px",
                      height: "38px",
                      borderRadius: "8px",
                      border: "1px solid #e2e6ea",
                      textAlign: "center",
                      fontWeight: "600",
                    }}
                    min="1"
                  />
                </div>
              </div>

              {/* Client Filter */}
              <div
                className={layout === "list" ? "" : ""}
                style={{
                  ...filterContainerStyle(layout === "list"),
                  minWidth: layout === "list" ? "100%" : "180px",
                }}
              >
                <div style={filterLabelStyle}>
                  <i className="bx bx-user" style={filterIconStyle}></i>
                  <span>Client</span>
                </div>
                <Select
                  onInputChange={handleEntersClients}
                  value={client}
                  placeholder="Select Client..."
                  onChange={handlerClientFinalValue}
                  options={clientOptions}
                  classNamePrefix="select2-selection"
                  isLoading={loading}
                  styles={{
                    control: base => ({
                      ...base,
                      borderRadius: "8px",
                      borderColor: "#e2e6ea",
                      minHeight: "38px",
                    }),
                  }}
                />
              </div>

              {/* Vehicle Filter */}
              {!vehicleDetailsId && (
                <div
                  style={{
                    ...filterContainerStyle(layout === "list"),
                    minWidth: layout === "list" ? "100%" : "180px",
                  }}
                >
                  <div style={filterLabelStyle}>
                    <i className="bx bx-car" style={filterIconStyle}></i>
                    <span>Vehicle</span>
                  </div>
                  <Select
                    onInputChange={handleEntersVehicle}
                    value={vehicle}
                    placeholder="Select Vehicle..."
                    onChange={handlerVehicleFinalValue}
                    options={vehicleOptions}
                    classNamePrefix="select2-selection"
                    isLoading={loading}
                    styles={{
                      control: base => ({
                        ...base,
                        borderRadius: "8px",
                        borderColor: "#e2e6ea",
                        minHeight: "38px",
                      }),
                    }}
                  />
                </div>
              )}

              {/* Staff Filter */}
              {isAnyRole([
                ROLE_TYPES.SUPER_ADMIN,
                ROLE_TYPES.ADMIN,
                ROLE_TYPES.ENQUIRY_MANAGER,
              ]) && (
                  <div
                    style={{
                      ...filterContainerStyle(layout === "list"),
                      minWidth: layout === "list" ? "100%" : "180px",
                    }}
                  >
                    <div style={filterLabelStyle}>
                      <i
                        className="bx bx-user-circle"
                        style={filterIconStyle}
                      ></i>
                      <span>Staff</span>
                    </div>
                    <Select
                      isMulti
                      onInputChange={handleEntersStaffs}
                      value={staff}
                      placeholder="Select Staff..."
                      onChange={handlerStaffsFinalValue}
                      options={staffOptions}
                      classNamePrefix="select2-selection"
                      isLoading={loading}
                      closeMenuOnSelect={false}
                      styles={{
                        control: base => ({
                          ...base,
                          borderRadius: "8px",
                          borderColor: "#e2e6ea",
                          minHeight: "38px",
                        }),
                      }}
                    />
                  </div>
                )}

              {/* Medium Filter */}
              <div
                style={{
                  ...filterContainerStyle(layout === "list"),
                  minWidth: layout === "list" ? "100%" : "160px",
                }}
              >
                <div style={filterLabelStyle}>
                  <i className="bx bx-broadcast" style={filterIconStyle}></i>
                  <span>Medium</span>
                </div>
                <Select
                  value={MediumOptions.find(opt => opt.value === medium)}
                  placeholder="Select Medium"
                  onChange={selectedOption =>
                    handleMediumValues(selectedOption?.value || "")
                  }
                  options={MediumOptions}
                  classNamePrefix="select2-selection"
                  styles={{
                    control: base => ({
                      ...base,
                      borderRadius: "8px",
                      borderColor: "#e2e6ea",
                      minHeight: "38px",
                    }),
                  }}
                />
              </div>

              {/* Lead Condition Filter */}
              <div
                style={{
                  ...filterContainerStyle(layout === "list"),
                  minWidth: layout === "list" ? "100%" : "160px",
                }}
              >
                <div style={filterLabelStyle}>
                  <i className="bx bx-star" style={filterIconStyle}></i>
                  <span>Condition</span>
                </div>
                <Select
                  value={LEAD_CONDITION_OPTIONS.find(opt => opt.value === leadCondition)}
                  placeholder="Select Condition"
                  onChange={selectedOption =>
                    handleLeadConditionValues(selectedOption?.value || "all")
                  }
                  options={LEAD_CONDITION_OPTIONS}
                  classNamePrefix="select2-selection"
                  styles={{
                    control: base => ({
                      ...base,
                      borderRadius: "8px",
                      borderColor: "#e2e6ea",
                      minHeight: "38px",
                    }),
                  }}
                />
              </div>

              {/* Lead Order Filter */}
              <div
                style={{
                  ...filterContainerStyle(layout === "list"),
                  minWidth: layout === "list" ? "100%" : "160px",
                }}
              >
                <div style={filterLabelStyle}>
                  <i className="bx bx-sort" style={filterIconStyle}></i>
                  <span>Sort By</span>
                </div>
                <Select
                  value={LEAD_ORDER_OPTIONS.find(opt => opt.value === orderValue)}
                  placeholder="Sort By"
                  onChange={selectedOption =>
                    handleOrderChange(selectedOption?.value || "createdAt_-1")
                  }
                  options={LEAD_ORDER_OPTIONS}
                  classNamePrefix="select2-selection"
                  styles={{
                    control: base => ({
                      ...base,
                      borderRadius: "8px",
                      borderColor: "#e2e6ea",
                      minHeight: "38px",
                    }),
                  }}
                />
              </div>

              {/* Type Filter - Dream Car */}
              <div style={filterContainerStyle(layout === "list")}>
                <div style={filterLabelStyle}>
                  <i className="bx bx-star" style={filterIconStyle}></i>
                  <span>Type</span>
                </div>
                <div>
                  <input
                    type="checkbox"
                    className="btn-check"
                    id={"dream-car-filter"}
                    autoComplete="off"
                    checked={typeValue === "dream_car"}
                    onChange={() => handleTypeValues()}
                  />
                  <label
                    htmlFor={"dream-car-filter"}
                    style={{
                      minWidth: "120px",
                      height: "38px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      borderRadius: "8px",
                      border:
                        typeValue === "dream_car"
                          ? "2px solid #f0ad4e"
                          : "1px solid #e2e6ea",
                      background:
                        typeValue === "dream_car"
                          ? "linear-gradient(135deg, #fff7ed 0%, #ffedd5 100%)"
                          : "#fff",
                      color: typeValue === "dream_car" ? "#ea580c" : "#6c757d",
                      fontWeight: "600",
                      fontSize: "13px",
                      cursor: "pointer",
                      transition: "all 0.2s ease",
                    }}
                    className="mb-0"
                  >
                    <i
                      className="bx bx-star"
                      style={{
                        marginRight: "6px",
                        color:
                          typeValue === "dream_car" ? "#f0ad4e" : "#adb5bd",
                      }}
                    ></i>
                    Dream Car
                  </label>
                </div>
              </div>

              {/* Date Range Filter */}
              <div
                style={{
                  ...filterContainerStyle(layout === "list"),
                  minWidth: layout === "list" ? "100%" : "auto",
                }}
              >
                <div style={filterLabelStyle}>
                  <i className="bx bx-calendar" style={filterIconStyle}></i>
                  <span>Date Range</span>
                </div>
                <div
                  className="d-flex"
                  style={{
                    gap: "8px",
                    flexWrap: layout === "list" ? "wrap" : "nowrap",
                  }}
                >
                  <div
                    className="position-relative"
                    style={{ display: "flex", alignItems: "center" }}
                  >
                    <input
                      type="date"
                      className="form-control"
                      onChange={e => handlerDateFrom(e)}
                      value={finalDateFormatted?.from || ""}
                      style={{
                        borderRadius: "8px",
                        border: "1px solid #e2e6ea",
                        height: "38px",
                        paddingRight: "30px",
                        fontSize: "13px",
                      }}
                    />
                    {finalDateFormatted?.from && (
                      <button
                        onClick={handlerClearDateFrom}
                        type="button"
                        style={{
                          position: "absolute",
                          right: "8px",
                          background: "none",
                          border: "none",
                          color: "#dc3545",
                          cursor: "pointer",
                          padding: "0",
                          fontSize: "16px",
                        }}
                      >
                        <i className="bx bx-x"></i>
                      </button>
                    )}
                  </div>
                  <span
                    style={{
                      display: "flex",
                      alignItems: "center",
                      color: "#adb5bd",
                      fontSize: "12px",
                    }}
                  >
                    to
                  </span>
                  <div
                    className="position-relative"
                    style={{ display: "flex", alignItems: "center" }}
                  >
                    <input
                      type="date"
                      className="form-control"
                      onChange={e => handlerDateTo(e)}
                      value={finalDateFormatted?.to || ""}
                      style={{
                        borderRadius: "8px",
                        border: "1px solid #e2e6ea",
                        height: "38px",
                        paddingRight: "30px",
                        fontSize: "13px",
                      }}
                    />
                    {finalDateFormatted?.to && (
                      <button
                        onClick={handlerClearDateTo}
                        type="button"
                        style={{
                          position: "absolute",
                          right: "8px",
                          background: "none",
                          border: "none",
                          color: "#dc3545",
                          cursor: "pointer",
                          padding: "0",
                          fontSize: "16px",
                        }}
                      >
                        <i className="bx bx-x"></i>
                      </button>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  )

  const toggleTopDrawer = () => {
    setPosition("right")
    setOpen(!open)
    setLayout("list")
    localStorage.setItem("layout", "list")
  }

  const onDrawerClose = () => {
    setOpen(false)
  }

  const handleStatusValue = useHandleStatusValue(statusCount, typeValue)

  const headers = [
    { label: "No", key: "no" },
    { label: "Date", key: "createdAt" },
    { label: "Client Name", key: "client_name" },
    { label: "Client Phone", key: "client_phone" },
    { label: "Client WhatsApp Number", key: "client_whatsappNumber" },
    { label: "Medium", key: "medium" },
    { label: "Type", key: "type" },
    { label: "Vehicle", key: "vehicle_name" },
    { label: "Vehicle Ownership Status", key: "ownership_status" },
    { label: "Variant Name", key: "variant_name" },
    { label: "Model Name", key: "model_name" },
    { label: "Message", key: "message" },
    { label: "Remarks", key: "remarks" },
    { label: "Status", key: "status" },
    { label: "Assignee", key: "assignee" },
    { label: "Branch", key: "branch" },
    { label: "Last Update", key: "updatedAt" },
  ]

  const formattedCreateDates = item => {
    return moment(item?.createdAt).format("DD/MM/YYYY h:m:a")
  }
  const formattedUpdateDates = item => {
    return moment(item?.updatedAt).format("DD/MM/YYYY h:m:a")
  }

  const handleExcelDownload = () => {
    dispatch(
      getExcelDownloadLead(
        page,
        sort,
        totalItemLimit,
        "",
        vehicleId,
        typeValue,
        clientId,
        medium,
        handleDateSearch(),
        branchId
      )
    )
  }

  const excelDownloadLeads = map(allLeadsExcel, (item, key) => ({
    ...item,
    no: key + 1,
    createdAt: formattedCreateDates(item),
    client_name: item?.client?.name,
    client_phone: item?.client?.phone,
    client_whatsappNumber: item?.client?.whatsappNumber, // add other client data
    medium: item.medium,
    type: item.type,
    vehicle_name: item.vehicle?.name,
    // variant_name: item?.variant?.name,
    model_name: item?.model?.name,
    // ownership_status: item?.vehicle?.ownershipStatus,
    message: item.message,
    remarks: item.remarks,
    status: item.status,
    assignee: item?.assignee?.name,
    branch: item?.branch?.branch_name || item?.branch?.name,
    updatedAt: formattedUpdateDates(item),
  }))

  const handleMediumValues = value => {
    setMedium(value)
    updateURLParams("medium", value)
  }

  const handleLeadConditionValues = value => {
    setLeadCondition(value)
    updateURLParams("leadCondition", value)
  }

  const handleOrderChange = value => {
    setOrderValue(value)
    updateURLParams("orderValue", value)
  }

  const handleTypeValues = () => {
    setTypeValue(typeValue === "dream_car" ? "purchase" : "dream_car")
  }

  useEffect(() => {
    if (location?.pathname?.length > 0) {
      switch (location?.pathname?.split("lead/")[1]) {
        case "sales":
          setTypeValue("sales")
          break
        case "purchase":
          setTypeValue("purchase")
          break

        default:
          setTypeValue("")
      }
    }
  }, [])

  useEffect(() => {
    if (location?.state?.sort) {
      setSort(location?.state?.sort)
    }
    if (location?.state?.medium) {
      setMedium(location?.state?.medium)
    }
    if (location?.state?.leadCondition) {
      setLeadCondition(location?.state?.leadCondition)
    }
    if (location?.state?.orderValue) {
      setOrderValue(location?.state?.orderValue)
    }
    // if (location?.state?.type) {
    //   setTypeValue(location?.state?.type)
    // }

    setTotalItemLimit(location?.state?.limit || 30)

    if (location?.state?.client) {
      setClient(location?.state?.clientName)
      setClientId(location?.state?.client)
    }

    if (location?.state?.vehicle) {
      setVehicle(location?.state?.vehicleName)
      setVehicleId(location?.state?.vehicle)
    }

    if (location?.state?.staff) {
      // Handle comma-separated staff IDs
      const staffIdsArray = location?.state?.staff.split(',').filter(id => id)
      setStaffId(staffIdsArray)

      // Reconstruct staff options from staffNames if available
      if (location?.state?.staffNames) {
        const namesArray = location?.state?.staffNames.split(', ')
        const staffOptions = staffIdsArray.map((id, index) => ({
          value: id,
          label: namesArray[index] || id
        }))
        setStaff(staffOptions)
      }
    }

    setFinalDateFormatted({
      ...finalDateFormatted,
      from: location?.state?.dateFrom,
      to: location?.state?.dateTo,
    })

    if (location?.state?.searchText !== undefined) {
      setSearchText(location.state.searchText)
      setDebouncedSearchText(location.state.searchText)
    }
  }, [location])

  const handleCreateLeadClick = () => {
    const typeValue =
      location?.pathname === "/lead/purchase" ? "Purchase" : "Sales"
    history.push(`/lead/create/new?type=${typeValue}`)
    dispatch(resetClientNumber())
  }

  const rowStyle = (row, rowIndex) => {
    const style = { padding: "4px 0" };
    if (row.leadCondition === 'superHot') {
      style.borderLeft = '3px solid #f46a6a';
      style.backgroundColor = 'rgba(244, 106, 106, 0.04)';
    } else if (row.leadCondition === 'hot') {
      style.borderLeft = '3px solid #f1b44c';
      style.backgroundColor = 'rgba(241, 180, 76, 0.04)';
    } else if (row.leadCondition === 'warm') {
      style.borderLeft = '3px solid #50a5f1';
      style.backgroundColor = 'rgba(80, 165, 241, 0.04)';
    }
    return style;
  };

  return (
    <React.Fragment>
      <DeleteModal
        show={isOpen?.status}
        onCloseClick={() => setIsOpen({ ...isOpen, status: false })}
        onDeleteClick={handleDeleteEvent}
      />
      <Row>
        <Col className="col-12">
          <Card >
            <CardBody className="mt-0 pt-0 px-3">
              <div>
                <ToolkitProvider
                  keyField="_id"
                  columns={handleColumns()}
                  data={allLeadData}
                  search
                >
                  {toolkitProps => (
                    <React.Fragment>
                      <div className="d-flex align-items-center flex-wrap gap-2 mt-2 mt-xl-0">
                        {/* Render All separately (or as first group) */}
                        <div className="btn-group d-flex align-items-center flex-wrap" role="group">
                          {handleStatusValue.filter(h => h.category === 'all').map((head, key) => (
                            <Fragment key={key}>
                              <input
                                type="radio"
                                className="btn-check w-fit"
                                name="btnradio"
                                id={head.value + key}
                                autoComplete="off"
                                checked={sort === head.value}
                                onChange={() => listChange(head?.value || "")}
                              />
                              <label
                                className="btn d-flex align-items-center w-fit"
                                htmlFor={head.value + key}
                                style={{
                                  whiteSpace: "nowrap",
                                  maxWidth: "fit-content",
                                  backgroundColor: sort === head.value ? "#2784ff" : "transparent",
                                  borderColor: sort === head.value ? "#2784ff" : "#deebff",
                                  color: sort === head.value ? "#fff" : "#333",
                                  borderWidth: "1px",
                                  borderStyle: "solid",
                                  borderRadius: "5px",
                                  margin: "2px",
                                  fontSize: "12px",
                                }}
                              >
                                {head?.label}
                                <Badge
                                  className={`font-size-10 ms-2 ${sort === head.value ? "badge-soft-light" : "badge-soft-primary"}`}
                                  pill
                                >
                                  {head?.count}
                                </Badge>
                              </label>
                            </Fragment>
                          ))}
                        </div>

                        {/* Management Group */}
                        {handleStatusValue.some(h => h.category === 'management') && (
                          <div className="btn-group d-flex align-items-center flex-wrap p-1 rounded" style={{ backgroundColor: "rgba(52, 195, 143, 0.05)" }} role="group">
                            {handleStatusValue.filter(h => h.category === 'management').map((head, key) => (
                              <Fragment key={key}>
                                <input
                                  type="radio"
                                  className="btn-check w-fit"
                                  name="btnradio"
                                  id={head.value + key}
                                  autoComplete="off"
                                  checked={sort === head.value}
                                  onChange={() => listChange(head?.value || "")}
                                />
                                <label
                                  className="btn d-flex align-items-center w-fit"
                                  htmlFor={head.value + key}
                                  style={{
                                    whiteSpace: "nowrap",
                                    maxWidth: "fit-content",
                                    backgroundColor: sort === head.value ? "#34c38f" : "white",
                                    borderColor: sort === head.value ? "#34c38f" : "#deebff",
                                    color: sort === head.value ? "#fff" : "#333",
                                    borderWidth: "1px",
                                    borderStyle: "solid",
                                    borderRadius: "5px",
                                    margin: "2px",
                                    fontSize: "12px",
                                  }}
                                >
                                  {head?.label}
                                  <Badge
                                    className={`font-size-10 ms-2 ${sort === head.value ? "badge-soft-light" : "badge-soft-success"}`}
                                    pill
                                  >
                                    {head?.count}
                                  </Badge>
                                </label>
                              </Fragment>
                            ))}
                          </div>
                        )}

                        {/* Sales Group */}
                        {handleStatusValue.some(h => h.category === 'sales') && (
                          <div className="btn-group d-flex align-items-center flex-wrap p-1 rounded" style={{ backgroundColor: "rgba(85, 110, 230, 0.05)" }} role="group">
                            {handleStatusValue.filter(h => h.category === 'sales').map((head, key) => (
                              <Fragment key={key}>
                                <input
                                  type="radio"
                                  className="btn-check w-fit"
                                  name="btnradio"
                                  id={head.value + key}
                                  autoComplete="off"
                                  checked={sort === head.value}
                                  onChange={() => listChange(head?.value || "")}
                                />
                                <label
                                  className="btn d-flex align-items-center w-fit"
                                  htmlFor={head.value + key}
                                  style={{
                                    whiteSpace: "nowrap",
                                    maxWidth: "fit-content",
                                    backgroundColor: sort === head.value ? "#556ee6" : "white",
                                    borderColor: sort === head.value ? "#556ee6" : "#deebff",
                                    color: sort === head.value ? "#fff" : "#333",
                                    borderWidth: "1px",
                                    borderStyle: "solid",
                                    borderRadius: "5px",
                                    margin: "2px",
                                    fontSize: "12px",
                                  }}
                                >
                                  {head?.label}
                                  <Badge
                                    className={`font-size-10 ms-2 ${sort === head.value ? "badge-soft-light" : "badge-soft-info"}`}
                                    pill
                                  >
                                    {head?.count}
                                  </Badge>
                                </label>
                              </Fragment>
                            ))}
                          </div>
                        )}

                        {/* Closed Group */}
                        {handleStatusValue.some(h => h.category === 'closed') && (
                          <div className="btn-group d-flex align-items-center flex-wrap p-1 rounded" style={{ backgroundColor: "rgba(244, 106, 106, 0.05)" }} role="group">
                            {handleStatusValue.filter(h => h.category === 'closed').map((head, key) => (
                              <Fragment key={key}>
                                <input
                                  type="radio"
                                  className="btn-check w-fit"
                                  name="btnradio"
                                  id={head.value + key}
                                  autoComplete="off"
                                  checked={sort === head.value}
                                  onChange={() => listChange(head?.value || "")}
                                />
                                <label
                                  className="btn d-flex align-items-center w-fit"
                                  htmlFor={head.value + key}
                                  style={{
                                    whiteSpace: "nowrap",
                                    maxWidth: "fit-content",
                                    backgroundColor: sort === head.value ? "#f46a6a" : "white",
                                    borderColor: sort === head.value ? "#f46a6a" : "#deebff",
                                    color: sort === head.value ? "#fff" : "#333",
                                    borderWidth: "1px",
                                    borderStyle: "solid",
                                    borderRadius: "5px",
                                    margin: "2px",
                                    fontSize: "12px",
                                  }}
                                >
                                  {head?.label}
                                  <Badge
                                    className={`font-size-10 ms-2 ${sort === head.value ? "badge-soft-light" : "badge-soft-danger"}`}
                                    pill
                                  >
                                    {head?.count}
                                  </Badge>
                                </label>
                              </Fragment>
                            ))}
                          </div>
                        )}
                      </div>

                      <Row className="d-flex align-items-center jus  justify-content-between pb-1">
                        <Col md="12">
                          <div className="position-relative d-flex align-items-center justify-content-between">
                            <div
                              className=" d-flex align-items-center justify-content-between"
                              style={{
                                gap: "10px",
                                marginTop: "10px",
                                marginBottom: "10px",
                              }}
                            >
                              <div
                                className="position-relative w-100"
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  backgroundColor: "#fff",
                                  border: "1px solid #dfe1e5",
                                  borderRadius: "24px",
                                  padding: "8px 16px",
                                  // boxShadow: searchText ? "0 1px 6px rgba(32,33,36,.28)" : "none",
                                  transition: "box-shadow 0.2s ease",
                                  minWidth: "400px",
                                }}
                              >
                                <i
                                  className="bx bx-search"
                                  style={{
                                    fontSize: "18px",
                                    color: "#9aa0a6",
                                    marginRight: "12px",
                                  }}
                                />
                                <input
                                  type="text"
                                  placeholder="Search leads by name, phone, vehicle..."
                                  value={searchText}
                                  onChange={handleSearchChange}
                                  style={{
                                    border: "none",
                                    outline: "none",
                                    width: "100%",
                                    fontSize: "14px",
                                    backgroundColor: "transparent",
                                    color: "#333",
                                  }}
                                />
                                {searchText && (
                                  <button
                                    type="button"
                                    onClick={handleClearSearch}
                                    style={{
                                      border: "none",
                                      background: "transparent",
                                      cursor: "pointer",
                                      padding: "0",
                                      marginLeft: "8px",
                                      display: "flex",
                                      alignItems: "center",
                                    }}
                                  >
                                    <i
                                      className="bx bx-x"
                                      style={{
                                        fontSize: "20px",
                                        color: "#70757a",
                                      }}
                                    />
                                  </button>
                                )}
                              </div>

                              <div
                                style={{ width: "100px" }}
                                className="d-flex align-items-center"
                              >
                                <div>
                                  <UncontrolledTooltip
                                    placement="bottom"
                                    target={"table-view-option"}
                                  >
                                    Table view
                                  </UncontrolledTooltip>
                                  <Button
                                    color={
                                      layout === "table" ? "warning" : "light"
                                    }
                                    className="btn-rounded"
                                    id="table-view-option"
                                    onClick={() => {
                                      setLayout("table")
                                      localStorage.setItem("layout", "table")
                                    }}
                                  >
                                    <PiTableFill />
                                  </Button>
                                </div>
                                <div>
                                  <UncontrolledTooltip
                                    placement="bottom"
                                    target={"list-view-option"}
                                  >
                                    List view
                                  </UncontrolledTooltip>
                                  <Button
                                    color={
                                      layout === "list" ? "warning" : "light"
                                    }
                                    className="btn-rounded ms-2 position-relative"
                                    id="list-view-option"
                                    onClick={toggleTopDrawer}
                                  >
                                    <FaList />
                                    {vehicle?.total ? (
                                      <span
                                        className="btn-rounded bg-danger font-size-10 position-absolute"
                                        style={{
                                          top: -6,
                                          right: -6,
                                          padding: 1,
                                          height: 20,
                                          width: 20,
                                          display: "flex",
                                          alignItems: "center",
                                          justifyContent: "center",
                                        }}
                                      >
                                        {vehicle?.total}
                                      </span>
                                    ) : (
                                      ""
                                    )}
                                  </Button>
                                </div>
                              </div>
                            </div>

                            {canCreateLead() ? (
                              <div
                                className={`${layout === "list"
                                  ? "my-2"
                                  : "d-flex justify-content-end"
                                  }`}
                              >
                                <div className=" p-1">
                                  <Button
                                    type="button"
                                    color="warning"
                                    className="btn w-100 mb-0 me-2"
                                    onClick={handleCreateLeadClick}
                                    style={{ minWidth: "150px" }}
                                  >
                                    <i className="mdi mdi-plus me-1" />
                                    Create Lead
                                  </Button>
                                </div>
                              </div>
                            ) : (
                              ""
                            )}
                          </div>
                        </Col>
                      </Row>
                      <div className="vehicle-option-table d-flex align-items-center">
                        {layout === "table" ? (
                          headerOptions
                        ) : (
                          <div className="w-100 mb-2" />
                        )}
                      </div>

                      {loading ? (
                        <Spinner color="secondary" className="d-block m-auto" />
                      ) : (
                        <>
                          {allLeads?.length >= 1 ? (
                            <Row>
                              <Col xl="12">
                                <div className="table-responsive">
                                  <BootstrapTable
                                    keyField={"id"}
                                    key={"id"}
                                    responsive
                                    bordered={false}
                                    striped={false}
                                    // defaultSorted={defaultSorted}
                                    // selectRow={selectRow}
                                    classes={
                                      "table align-middle table-nowrap table-sm"
                                    }
                                    headerWrapperClasses={"thead-light"}
                                    rowStyle={rowStyle}
                                    {...toolkitProps.baseProps}
                                  // onTableChange={handleTableChange}
                                  />
                                </div>
                              </Col>
                            </Row>
                          ) : (
                            <p className="my-4 mx-3 ">No Data !</p>
                          )}
                          <div className="d-flex align-items-center justify-content-between px-4">
                            <div className="w-75">
                              <MyPagination
                                totalPages={pages}
                                page={page}
                                setPage={setPage}
                              />
                            </div>

                            <div>
                              {allLeads?.length >= 1 ? (
                                <ExcelDownload
                                  title="Lead Reports"
                                  headers={headers}
                                  excelDownloadData={excelDownloadLeads}
                                  isLoading={excelLoading}
                                  onDownloadClick={handleExcelDownload}
                                />
                              ) : (
                                ""
                              )}
                            </div>
                          </div>
                        </>
                      )}
                    </React.Fragment>
                  )}
                </ToolkitProvider>
              </div>
            </CardBody>
          </Card>
        </Col>
      </Row>
      <ReactDrawer open={open} position={position} onClose={onDrawerClose}>
        <SimpleBar style={{ height: "900px", boxShadow: "none" }}>
          <div data-simplebar className="h-100">
            <div className="rightbar-title px-3 py-4">
              <Link
                to="#"
                onClick={onDrawerClose}
                className="right-bar-toggle float-end"
              >
                <i className="mdi mdi-close noti-icon" />
              </Link>
              <p className="m-0">More Options</p>
            </div>
            <hr className="my-0" />
            <div className="vehicle-option-sidebar">{headerOptions}</div>
          </div>
        </SimpleBar>
      </ReactDrawer>
    </React.Fragment>
  )
}

export default Leads;

export const LEAD_ORDER_OPTIONS = [
  { label: "Newest to Oldest", value: "createdAt_-1" },
  { label: "Oldest to Newest", value: "createdAt_1" },
  { label: "Recently Updated", value: "updatedAt_-1" },
  { label: "Least Recently Updated", value: "updatedAt_1" },
];
Leads.propTypes = {
  vehicleDetailsId: PropTypes.string,
}

const typeOptions = [
  { label: "All", value: "" },
  { label: "Purchase", value: "purchase" },
  { label: "Sales", value: "sales" },
  { label: "Dream Car", value: "dream_car" },
]

const MediumOptions = [
  { label: "All", value: "" },
  { label: "Social Media", value: "social" },
  { label: "Walk-In", value: "direct" },
  { label: "Call", value: "call" },
  { label: "Website", value: "website" },
  { label: "OLX", value: "olx" },
]

export const LEAD_CONDITION = {
  SUPER_HOT: 'superHot',
  HOT: 'hot',
  WARM: 'warm',
  NORMAL: 'normal',
}

const LEAD_CONDITION_OPTIONS = [
  { label: "All", value: "all" },
  { label: "Super Hot", value: LEAD_CONDITION.SUPER_HOT },
  { label: "Hot", value: LEAD_CONDITION.HOT },
  { label: "Warm", value: LEAD_CONDITION.WARM },
  { label: "Normal", value: LEAD_CONDITION.NORMAL },
]
